var map = {
	"./elements/ChannelFilter.vue": "tIfi",
	"./elements/OrderColumn.vue": "IKz8",
	"./elements/Paginator.vue": "FtDQ",
	"./elements/SmileWithText.vue": "xrNE",
	"./elements/imageBrowser.vue": "AjWd",
	"./elements/modal.vue": "gcUu",
	"./elements/modals/archive.vue": "1UnJ",
	"./elements/modals/confirm.vue": "r0EM",
	"./elements/modals/delete.vue": "SKl2",
	"./elements/modals/publish.vue": "kU1+",
	"./elements/modals/publishError.vue": "OrEq",
	"./elements/modals/recover.vue": "bEky",
	"./elements/modals/referrals.vue": "1A6t",
	"./elements/modals/republish.vue": "y0qp",
	"./elements/modals/suspend.vue": "MKt2",
	"./elements/panelWrapper.vue": "uRV9",
	"./elements/simplePanel.vue": "hcI8",
	"./forms/ForgotPassword.vue": "NZr1",
	"./forms/Login.vue": "I9So",
	"./forms/ResetPassword.vue": "EJFG",
	"./forms/elements/SimpleImageUploader.vue": "m/ZM",
	"./forms/elements/TagsInput.vue": "YXn5",
	"./forms/elements/button.vue": "84Q0",
	"./forms/elements/colorPicker.vue": "6t7R",
	"./forms/elements/customchoice.vue": "FJ34",
	"./forms/elements/dateInput.vue": "FLvZ",
	"./forms/elements/imageUploader.vue": "92ka",
	"./forms/elements/inputTag.vue": "4Uki",
	"./forms/elements/multiselect.vue": "WhzH",
	"./forms/elements/selectableBox.vue": "uUo5",
	"./forms/elements/simpleInput.vue": "Drlv",
	"./forms/elements/switcher.vue": "akag",
	"./forms/elements/textEditor.vue": "wo0P",
	"./layout-elements/nav.vue": "FlJD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+vxT";


//////////////////
// WEBPACK FOOTER
// ./src/components .*\.vue$
// module id = +vxT
// module chunks = 16